import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static outlets = [
        'profile--reputation-prizes-edit-modal',
    ];

    openEditModal(event) {
        event.preventDefault();
        showPreloader();

        const $textarea = $('#reputation-prizes-textarea-readonly');
        const data = $textarea.length ? ($textarea.summernote('code') ?? '') : '';
        this.profileReputationPrizesEditModalOutlet.openModal(data);

        hidePreloader();
    }
}
